import { Helmet } from "react-helmet";
import Notifications from '../components/Notifications'
import pic1 from '../assets/photos/pic1.jpg'
import pic2 from '../assets/photos/pic2.jpg'
import pic3 from '../assets/photos/pic3.jpg'

import pic4 from '../assets/constructionUpdates/DJI_0952.JPG'
import pic5 from '../assets/constructionUpdates/DJI_0956.JPG'
import pic6 from '../assets/constructionUpdates/DJI_0961.JPG'

import pic7 from '../assets/photos/IMG_0704.JPG'
import pic8 from '../assets/photos/IMG_0706.JPG'
import pic9 from '../assets/photos/IMG_0723.JPG'

import pic10 from '../assets/photos/IMG_0725.JPG'
import pic11 from '../assets/photos/IMG_0730.JPG'
import pic12 from '../assets/photos/IMG_0753.JPG'

import pic13 from '../assets/photos/0C5A0406.jpg'
import pic14 from '../assets/photos/0C5A0411.jpg'
import pic15 from '../assets/photos/0C5A0451.jpg'
import pic16 from '../assets/photos/0C5A0468.jpg'
import pic17 from '../assets/photos/0C5A0474.jpg'

import pic18 from '../assets/photos/34th St. & Milwaukee_Upland Groundbreaking_1.jpg'
import pic19 from '../assets/photos/34th St. & Milwaukee_Upland Groundbreaking_4.jpg'
import pic20 from '../assets/photos/34th St. & Milwaukee_Upland Groundbreaking_5.jpg'
import pic21 from '../assets/photos/34th St. & Milwaukee_Upland Groundbreaking_6.jpg'
import pic22 from '../assets/photos/34th St. & Milwaukee_Upland Groundbreaking_7.jpg'

import PastNotifications from "../components/PastNotifications";

/*
EVENTS JSON:
    {
        "key": 1,
        "title": "146th Street – Quaker Avenue to Indiana Avenue - Ribbon Cutting Ceremony",
        "timeRange": "9:00AM",
        "dateRange": "Friday 09/05/2025",
        "endDateTime": "2025-09-05 12:00",
        "innerText": "Ribbon Cutting Ceremony for 146th Street – Quaker Avenue to Indiana Avenue"
    }
*/

export default function Events() {
    const pastEventsList = ["98th Street (Alcove Avenue to Upland Avenue) Groundbreaking"]

    return (
        <div>
            <Helmet>
                <meta property="og:description" content="Events reguarding projects the Lubbock 2022 Street Bond Program." />
                <meta property="og:title" content="Events | City of Lubbock Street Bond" />
                <meta property="og:url" content="https://www.lubbock2022streetbond.com/events" />
            </Helmet>
            <div className="flex-shrink-0 modular min-vh-100">
                <img src={`/assets/downtown${Math.floor(Math.random() * 3)}.png`} className="d-block w-100" style={{ objectFit: "cover", height: "300px" }} alt="Events" />
                <div className="container">
                    <div className='row text-start mt-4'>
                        <h1 className='mb-4' style={{ color: "#00354C" }}>Upcoming Events</h1>
                        <Notifications />
                    </div>
                    <div className='row text-start mt-4'>
                        <h1 style={{ color: "#00354C" }}>Past Events</h1>
                        <PastNotifications />
                        <div className="card mt-3 px-0">
                            <div className="card-header">
                                <h5 className="my-0">34th Street (Milwaukee Avenue to Upland Avenue) Ground Breaking Ceremony 01/21/2026 at 1:30PM</h5>
                            </div>
                            <div className="card-body row">
                                <div className="col-4">
                                    <img src={pic18} className="p-2 img-fluid" />
                                </div>
                                <div className="col-4">
                                    <img src={pic19} className="p-2 img-fluid" />
                                </div>
                                <div className="col-4">
                                    <img src={pic20} className="p-2 img-fluid" />
                                </div>
                                 <div className="col-4">
                                    <img src={pic21} className="p-2 img-fluid" />
                                </div>
                                 <div className="col-4">
                                    <img src={pic22} className="p-2 img-fluid" />
                                </div>
                            </div>
                        </div>
                        <div className="card mt-3 px-0">
                            <div className="card-header">
                                <h5 className="my-0">Milwaukee Avenue (4th Street to the North City Limits) Groundbreaking Ceremony 11/25/2025 at 1:30 PM.</h5>
                            </div>
                            <div className="card-body row">
                                <div className="col-4">
                                    <img src={pic13} className="p-2 img-fluid" />
                                </div>
                                <div className="col-4">
                                    <img src={pic14} className="p-2 img-fluid" />
                                </div>
                                <div className="col-4">
                                    <img src={pic15} className="p-2 img-fluid" />
                                </div>
                                 <div className="col-4">
                                    <img src={pic16} className="p-2 img-fluid" />
                                </div>
                                 <div className="col-4">
                                    <img src={pic17} className="p-2 img-fluid" />
                                </div>
                            </div>
                        </div>
                        <div className="card mt-3 px-0">
                            <div className="card-header">
                                <h5 className="my-0">98th Street (Alcove Avenue to Upland Avenue) Ribbon Cutting Ceremony 09/05/2025 at 10:30 AM.</h5>
                            </div>
                            <div className="card-body row">
                                <div className="col-4">
                                    <img src={pic10} className="p-2 img-fluid" />
                                </div>
                                <div className="col-4">
                                    <img src={pic11} className="p-2 img-fluid" />
                                </div>
                                <div className="col-4">
                                    <img src={pic12} className="p-2 img-fluid" />
                                </div>
                            </div>
                        </div>
                        <div className="card mt-3 px-0">
                            <div className="card-header">
                                <h5 className="my-0">146th Street (Quaker Avenue to Indiana Avenue) Ribbon Cutting Ceremony 09/05/2025 at 9 AM.</h5>
                            </div>
                            <div className="card-body row">
                                <div className="col-4">
                                    <img src={pic7} className="p-2 img-fluid" />
                                </div>
                                <div className="col-4">
                                    <img src={pic8} className="p-2 img-fluid" />
                                </div>
                                <div className="col-4">
                                    <img src={pic9} className="p-2 img-fluid" />
                                </div>
                            </div>
                        </div>
                        <div className="card mt-3 px-0">
                            <div className="card-header">
                                <h5 className="my-0">146th Street (Quaker Avenue to Indiana Avenue) Groundbreaking 7/11/2024 at 10 AM.</h5>
                            </div>
                            <div className="card-body row">
                                <div className="col-4">
                                    <img src={pic4} className="p-2 img-fluid" />
                                </div>
                                <div className="col-4">
                                    <img src={pic5} className="p-2 img-fluid" />
                                </div>
                                <div className="col-4">
                                    <img src={pic6} className="p-2 img-fluid" />
                                </div>
                            </div>
                        </div>
                        <div className="card mt-3 px-0">
                            <div className="card-header">
                                <h5 className="my-0">98th Street (Alcove Avenue to Upland Avenue) Groundbreaking.</h5>
                            </div>
                            <div className="card-body row">
                                <div className="col-4">
                                    <img src={pic1} className="p-2 img-fluid" />
                                </div>
                                <div className="col-4">
                                    <img src={pic2} className="p-2 img-fluid" />
                                </div>
                                <div className="col-4">
                                    <img src={pic3} className="p-2 img-fluid" />
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}